import { ResourcesProvider } from './resources.context';
import { ResourcesView } from './resources.view';

export const Resources = () => (
  <ResourcesProvider>
    <ResourcesView />
  </ResourcesProvider>
);
